import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Name', prop: 'name' },
  { title: 'File Name', prop: 'file_name' },
  { title: 'Content Type', prop: 'content_type' },
  { title: 'File Size', prop: 'file_size', format: 'filesize' },
  { title: 'Created', prop: 'created_at', format: 'date' },
  { title: 'Updated', prop: 'updated_at', format: 'date' }
]

const filters = [
  { name: 'Filter by name', prop: 'filters.name_ilike', type: 'text', enabled: true },
  { name: 'Filter by content type', prop: 'filters.content_type_ilike', type: 'text', enabled: true }
]

const defaults = {
  order: [
    { column: 'name', direction: 'asc' }
  ]
}

const Media = (props) => (
  <List
    title='Media'
    apiPath='admin/media'
    columns={columns}
    filters={filters}
    defaults={defaults}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    buildMenuItems={menuItems}
  />
)

export default Media
